import React, { useContext, useEffect } from 'react';
import SocketContext from '../../context/SocketContext';
import { Button } from 'react-bootstrap';
import { FaVideo, FaTimes } from 'react-icons/fa';

const GlobalCallNotification = ({ onAccept, onDecline }) => {
    const { incomingCall, socket, clearIncomingCall } = useContext(SocketContext);

    // Auto-timeout if the agency hangs up before answering
    useEffect(() => {
        if (!socket) return;
        
        const handleCallEnded = () => {
            clearIncomingCall();
        };
        
        socket.on('call-ended', handleCallEnded);
        
        return () => {
            socket.off('call-ended', handleCallEnded);
        };
    }, [socket, clearIncomingCall]);

    if (!incomingCall) return null;

    const handleAccept = () => {
        onAccept(incomingCall);
    };

    const handleDecline = () => {
        if (socket) {
            socket.emit('decline-call', { 
                responderId: incomingCall.targetUserId, // Assuming we'll attach this locally when we register
                callerId: incomingCall.callerId 
            });
        }
        clearIncomingCall();
        if (onDecline) onDecline();
    };

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#fff',
            borderLeft: '5px solid #28a745',
            borderRadius: '8px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            padding: '20px',
            zIndex: 9999, // Force it above everything
            display: 'flex',
            flexDirection: 'column',
            minWidth: '300px',
            animation: 'slideInRight 0.5s ease-out'
        }}>
            <style>
                {`
                    @keyframes slideInRight {
                        from { transform: translateX(100%); opacity: 0; }
                        to { transform: translateX(0); opacity: 1; }
                    }
                    @keyframes pulseRing {
                        0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7); }
                        70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
                        100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
                    }
                `}
            </style>
            
            <div className="d-flex align-items-center mb-3">
                <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: '#e8f5e9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    animation: 'pulseRing 2s infinite'
                }}>
                    <FaVideo color="#28a745" size={24} />
                </div>
                <div>
                    <h5 className="mb-1 fw-bold text-dark">Incoming Video Call</h5>
                    <p className="mb-0 text-muted small">
                        from {incomingCall.callerName || 'Agency'}
                    </p>
                </div>
            </div>
            
            <div className="d-flex gap-2">
                <Button 
                    variant="success" 
                    className="flex-grow-1 d-flex justify-content-center align-items-center gap-2"
                    onClick={handleAccept}
                >
                    <FaVideo /> Accept
                </Button>
                <Button 
                    variant="danger" 
                    className="flex-grow-1 d-flex justify-content-center align-items-center gap-2"
                    onClick={handleDecline}
                >
                    <FaTimes /> Decline
                </Button>
            </div>
        </div>
    );
};

export default GlobalCallNotification;
